"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sendVoiceCode = sendVoiceCode;
exports.resetVoiceCode = resetVoiceCode;
exports.startTimer = startTimer;

var _constants = require('../constants/');

function sendVoiceCode(login, source, phone) {
    return {
        types: [_constants.VoiceCodeConstants.VOICE_CODE_FORM_REQUEST, _constants.VoiceCodeConstants.VOICE_CODE_FORM_SUCCESS, _constants.VoiceCodeConstants.VOICE_CODE_FORM_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.sendVoiceCode(login, source, phone);
        }
    };
}

function resetVoiceCode() {
    return {
        type: _constants.VoiceCodeConstants.VOICE_CODE_FORM_RESET
    };
}

function startTimer(t) {
    return {
        type: _constants.VoiceCodeConstants.SET_TIMER,
        timerState: 'start',
        time: t
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/actions/voice_code.js
// module id = 141
// module chunks = 0